/* eslint-disable @typescript-eslint/no-unused-vars */
import { styled } from "@mui/material";
import Button from "@mui/material/Button";
import { useLocation } from "react-router-dom";
import { ReactComponent as ScopelyIcon } from "../../../assets/ScopelyLogo.svg";
import { useFacebookContext } from "../../../contexts/FacebookProvider";
import { ConnectionStatus } from "../../../contexts/FacebookProvider/index";
import { useGoogleAnalyticsContext } from "../../../contexts/GoogleAnalyticsProvider";
import { useScopelyIdentityContext } from "../../../contexts/ScopelyIdentityProvider";
import {
	LOCAL_STORAGE_LOGIN_FROM,
	useWebStoreContext
} from "../../../contexts/WebStoreProvider";
import { LoginType } from "../../../domain/Login/LoginGoogleAnalyticsHelper";

const ScopelyInternalLoginButton = styled(Button)`
	font-family: "Poppins", sans-serif;
	display: block;
	width: 100%;
	background-color: #4f5794;
	color: "white";
	font-size: 0.7rem;
	text-transform: none;
	position: relative;
	line-height: 2.5;
	&:hover {
		background-color: #444b80;
	}
`;
//background-color: #4f5794;

const ScopelyLoginButton = ({
	onClick,
	hideLogoutState = false,
	source,
	cbClick,
	prevCb,
	// default style assumed to be after Facebook login button element
	style = { marginTop: "0.75rem" }
}: {
	onClick?: () => void;
	cbClick?: () => void;
	prevCb?: () => void;
	hideLogoutState?: boolean;
	source: string;
	style?: React.CSSProperties;
}) => {
	const location = useLocation();
	const { logout } = useWebStoreContext();
	const { connectionStatus } = useFacebookContext();
	const {
		isConnected,
		isScopelyIdentityReady,
		startLogin,
		setRedirectTo,
		initiateLogin
	} = useScopelyIdentityContext();
	const { loginGoogleAnalyticsHelper, reportPlaygamiEvent } =
		useGoogleAnalyticsContext();

	return (
		<>
			{!isConnected ? (
				<ScopelyInternalLoginButton
					variant="contained"
					onClick={() => {
						prevCb && prevCb();
						loginGoogleAnalyticsHelper.reportLoginOptionClick(
							LoginType.Scopely,
							source
						);
						reportPlaygamiEvent("tp.web_frontend", {
							event_name: "login_option_click",
							event_type: source,
							action: "login_option_click",
							login_type: LoginType.Scopely,
							source
						});
						if (onClick) {
							onClick();
						} else {
							const feature = source.split("#").pop();
							if (feature) {
								localStorage.setItem(LOCAL_STORAGE_LOGIN_FROM, source);
							}
							//startLogin(location.pathname);
							initiateLogin(location.pathname);
							setRedirectTo(location.pathname);
						}
						cbClick && cbClick();
					}}
					style={style}
					disabled={
						!isScopelyIdentityReady ||
						connectionStatus !== ConnectionStatus.UNKNOWN
					}
				>
					<ScopelyIcon
						style={{
							width: "auto",
							height: "1.5em",
							marginRight: "0.4rem",
							verticalAlign: "middle"
						}}
					/>
					Login with Scopely
				</ScopelyInternalLoginButton>
			) : (
				!hideLogoutState && (
					<ScopelyInternalLoginButton
						variant="outlined"
						onClick={logout}
						style={style}
						disabled={!isScopelyIdentityReady}
					>
						Logout
					</ScopelyInternalLoginButton>
				)
			)}
		</>
	);
};

export default ScopelyLoginButton;
